/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：837
 */

var r = require(/* 168 */"../1648/168")
module.exports = !r(function () {
  return Object.isExtensible(Object.preventExtensions({}))
})
